import { useTheme } from 'foundations-theming/utils';
import { List } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import UISelect from 'UIComponents/input/UISelect';
import classNames from 'classnames';
import I18n from 'I18n';
import unescapedText from 'I18n/utils/unescapedText';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterOperatorMultiStringInput = ({
  disabled,
  'data-selenium-test': seleniumSelector,
  error,
  inputUse,
  multiCollapseLimit,
  onChange,
  onBlur,
  readOnly,
  value
}) => {
  const trellisTheme = useTheme();
  const onBlurLocal = () => {
    if (typeof onBlur === 'function') {
      onBlur();
    }
  };
  return /*#__PURE__*/_jsx(FormControl, {
    "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
    error: error.get('error'),
    validationMessage: error.get('error') ? error.get('message') : null,
    children: /*#__PURE__*/_jsx(UISelect, {
      allowCreate: true
      //arrowRender is an 'undocumented' property for UISelect.
      // This is being hacked as a Select-arrow with 0 opacity to satisfy hiding the arrow,
      // but allowing Acceptance Test utilities which depend on it to continue to work.
      // visibilty:hidden, display:none are all not options because ATs will not interect with hidden elements.
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      ,
      arrowRenderer: () =>
      /*#__PURE__*/
      // @bend-expect trellis-tokenized re-implement/remove this behavior when moving to the new select component
      _jsx("div", {
        className: "Select-arrow",
        style: {
          opacity: 0
        }
      })
      // UISelect has a dark mode option, but because we use a multi select
      // with the option to add new values, the UISelect has an anchorType of
      // combined, of which the given dark mode does not work on.
      // Thus the need to manually set the background color.
      ,
      style: inputUse === 'on-dark' ? {
        backgroundColor: trellisTheme.color['do-not-use-olaf']
      } : undefined
      // UISelects without an anchor type must use className selenium selectors
      ,
      className: classNames(seleniumSelector),
      disabled: disabled,
      multi: true,
      multiCollapseLimit: multiCollapseLimit,
      noResultsText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.customerDataFilters.FilterOperatorMultiStringInput.resultsText"
      }),
      onBlur: onBlurLocal,
      onChange: evt => onChange(syntheticEvent(List(evt.target.value))),
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.customerDataFilters.FilterOperatorMultiStringInput.placeholder"
      }),
      promptTextCreator: userInput => unescapedText('customerDataFiltersUI.customerDataFilters.FilterOperatorMultiStringInput.promptText', {
        value: userInput
      }),
      readOnly: readOnly,
      value: value && value.toArray() || []
    })
  });
};
export default FilterOperatorMultiStringInput;